var _TYPES_COMPONENT_MAP, _TYPES_EXCLUDED_PROPS;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import omit from 'lodash/omit';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ProgressIndicator from '../progressIndicator/ProgressIndicator';
import Icon from '../icon/Icon';
import CheckChunkySvg from '../iconography/icons/CheckChunky';
import CrossChunkySvg from '../iconography/icons/CrossChunky';
import * as constants from './constants';
import { isIconComponent, getButtonClassNames } from './utils';

var ButtonButton = function ButtonButton(_ref) {
  var children = _ref.children,
      componentAttrs = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement("button", _extends({}, componentAttrs, {
    type: "button"
  }), children);
};

var ButtonSubmit = function ButtonSubmit(_ref2) {
  var children = _ref2.children,
      componentAttrs = _objectWithoutProperties(_ref2, ["children"]);

  return React.createElement("button", _extends({}, componentAttrs, {
    type: "submit"
  }), children);
};

var ButtonLink = function ButtonLink(_ref3) {
  var children = _ref3.children,
      componentAttrs = _objectWithoutProperties(_ref3, ["children"]);

  return React.createElement("a", componentAttrs, children);
};

var Loading = function Loading(_ref4) {
  var className = _ref4.className,
      style = _ref4.style;
  return React.createElement("div", {
    className: className
  }, React.createElement(ProgressIndicator, {
    shape: "circular",
    size: "small-chunky",
    style: constants.BUTTON_PROGRESS_STYLE[style]
  }));
};

var Success = function Success(_ref5) {
  var className = _ref5.className;
  return React.createElement("span", {
    className: className
  }, React.createElement(Icon, {
    size: "small",
    type: React.createElement(CheckChunkySvg, null),
    animated: true
  }));
};

var Fail = function Fail(_ref6) {
  var className = _ref6.className;
  return React.createElement("i", {
    className: className
  }, React.createElement(Icon, {
    size: "small",
    type: React.createElement(CrossChunkySvg, null)
  }));
};

var TYPES_COMPONENT_MAP = (_TYPES_COMPONENT_MAP = {}, _defineProperty(_TYPES_COMPONENT_MAP, constants.TYPE_BUTTON, ButtonButton), _defineProperty(_TYPES_COMPONENT_MAP, constants.TYPE_SUBMIT, ButtonSubmit), _defineProperty(_TYPES_COMPONENT_MAP, constants.TYPE_LINK, ButtonLink), _TYPES_COMPONENT_MAP);
var TYPES_EXCLUDED_PROPS_MAP = (_TYPES_EXCLUDED_PROPS = {}, _defineProperty(_TYPES_EXCLUDED_PROPS, constants.TYPE_BUTTON, []), _defineProperty(_TYPES_EXCLUDED_PROPS, constants.TYPE_SUBMIT, []), _defineProperty(_TYPES_EXCLUDED_PROPS, constants.TYPE_LINK, []), _TYPES_EXCLUDED_PROPS);

var ButtonBody = function ButtonBody(_ref7) {
  var isLoading = _ref7.isLoading,
      isSuccessful = _ref7.isSuccessful,
      isNotSuccessful = _ref7.isNotSuccessful,
      children = _ref7.children,
      style = _ref7.style;
  var component;
  var className = classNames('eds-btn__children', {
    'eds-fx--fade-out-up ': isLoading
  });
  var componentClassName = classNames('eds-btn__extra', 'eds-fx--fade-in', {
    'eds-fx--delay-3': isLoading || isNotSuccessful
  });

  if (isLoading) {
    component = React.createElement(Loading, {
      className: componentClassName,
      style: style
    });
  }

  if (isSuccessful) {
    component = React.createElement(Success, {
      className: componentClassName
    });
  }

  if (isNotSuccessful) {
    component = React.createElement(Fail, {
      className: componentClassName
    });
  }

  return React.createElement("div", null, React.createElement("div", {
    className: className
  }, children), component);
};

var Button =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "_handleClick",
    value: function _handleClick(syntheticEvent) {
      syntheticEvent.stopPropagation(); // simple wrapper for onClick so that the event object doesn't
      // get passed to the callback

      if (this.props.onClick) {
        syntheticEvent.persist();

        if (this.props.type === constants.TYPE_LINK) {
          syntheticEvent.preventDefault();
        }

        this.props.onClick(syntheticEvent);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      // TODO: This implementation should be revisited so that we hopefully
      // don't need to do this
      // eslint-disable-next-line react/no-find-dom-node
      ReactDOM.findDOMNode(this).focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isFollowing = _this$props.isFollowing,
          isLoading = _this$props.isLoading,
          isSuccessful = _this$props.isSuccessful,
          isNotSuccessful = _this$props.isNotSuccessful,
          phab = _this$props.phab,
          size = _this$props.size,
          style = _this$props.style,
          type = _this$props.type,
          __containerClassName = _this$props.__containerClassName,
          extraAttrs = _objectWithoutProperties(_this$props, ["children", "isFollowing", "isLoading", "isSuccessful", "isNotSuccessful", "phab", "size", "style", "type", "__containerClassName"]);

      var disabled = this.props.disabled;
      var componentChildren = React.Children.toArray(children);
      var childCount = componentChildren.length;
      var iconCount = componentChildren.filter(isIconComponent).length;
      var hasIconsOnly = childCount === iconCount;
      var hasIconsAndOtherChildren = childCount - iconCount > 0 && iconCount > 0;
      var className = getButtonClassNames({
        children: children,
        disabled: disabled,
        hasIconsAndOtherChildren: hasIconsAndOtherChildren,
        hasIconsOnly: hasIconsOnly,
        isFollowing: isFollowing,
        isLoading: isLoading,
        isSuccessful: isSuccessful,
        isNotSuccessful: isNotSuccessful,
        phab: phab,
        size: size,
        style: style,
        type: type,
        __containerClassName: __containerClassName
      });
      var onClick;
      var accessibilityProps = {};

      if (disabled || isLoading || isSuccessful || isNotSuccessful) {
        accessibilityProps = _objectSpread({}, accessibilityProps, {
          'aria-disabled': true
        });
        disabled = true;
      } else {
        // set click handler if not disabled because
        // anchor-type buttons don't respect disabled attribute
        onClick = this._handleClick.bind(this);
      }

      var componentAttrs = omit.apply(void 0, [_objectSpread({}, extraAttrs, {
        className: className,
        disabled: disabled,
        onClick: onClick
      })].concat(_toConsumableArray(TYPES_EXCLUDED_PROPS_MAP[type])));
      var ButtonSubComponent = TYPES_COMPONENT_MAP[type];
      var buttonBody = children; // ButtonBody provides an inner container for showing loading, success, and error states
      // that is otherwise not needed (and in fact, may break components like ExpandableCardContent
      // that depend on children to be the direct descendants of ButtonSubComponent)

      if (isLoading || isSuccessful || isNotSuccessful) {
        buttonBody = React.createElement(ButtonBody, {
          style: style,
          isLoading: isLoading,
          isSuccessful: isSuccessful,
          isNotSuccessful: isNotSuccessful
        }, children);
      }

      return React.createElement(ButtonSubComponent, _extends({}, componentAttrs, accessibilityProps), buttonBody);
    }
  }]);

  return Button;
}(React.PureComponent);

_defineProperty(Button, "propTypes", {
  /**
   * Contents of the button
   */
  children: PropTypes.node.isRequired,

  /**
   * Defines the type of button. (button, submit, or link)
   */
  type: PropTypes.oneOf(constants.TYPES),

  /**
   * Changes the style of the button.
   * Available styles: none, anchor, link, neutral, fill, follow
   */
  style: PropTypes.oneOf(constants.STYLES),

  /**
   * Changes button size
   * Available sizes: responsive, block
   */
  size: PropTypes.oneOf(constants.SIZES),

  /**
   * Set active styles to button
   */
  isFollowing: PropTypes.bool,

  /**
  * Adds a loading spinner to button
  */
  isLoading: PropTypes.bool,

  /**
  * Adds a checkmark to button
  */
  isSuccessful: PropTypes.bool,

  /**
  * Adds a cross to button
  */
  isNotSuccessful: PropTypes.bool,

  /**
   * Callback function invoked when the button is clicked.
   * () => { }
   */
  onClick: PropTypes.func,

  /**
  * Disables the button
  */
  disabled: PropTypes.bool,

  /**
   * is a phab the button
   */
  phab: PropTypes.bool,

  /**
   * Container class name
   */
  __containerClassName: PropTypes.string
});

_defineProperty(Button, "defaultProps", {
  type: constants.TYPE_BUTTON,
  style: constants.STYLE_NEUTRAL
});

export { Button as default };